export const update = {
  updateSuccessfully: '顧客の更新に成功しました！',
}
